module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("rci4I"))).then(() => parcelRequire('d0iPb'));